module.exports = __webpack_public_path__ + "static/assets/2e7d6d8fcdb5f0e62b69c34d7c48423f.svg";